module.exports = __webpack_public_path__ + "static/img/presysv41.99823d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/presysv41.png
// module id = v7m+
// module chunks = 1